import { CAMERA_FACING_MODE, ElementType, Question } from "@archetypes/form";
import {
  DateTimeIcon,
  DropDownIcon,
  EntityIcon,
  FileUploadIcon,
  LocationPickerIcon,
  MultiLinetextIcon,
  MultiSelectIcon,
  MultipleChoiceIcon,
  RankingIcon,
  RatingIcon,
  RichTextIcon,
  SliderIcon,
  SignatureIcon,
  SingleChoiceIcon,
  SingleLinetextIcon,
  TextBlockIcon,
  UserIcon,
  VideoIcon,
  YesNoIcon,
  Email,
  MobilePoIcon,
  LinkIcon,
  MoneyIcon,
  TermsConditionIcon,
  TimeIcon,
  ImageIcon,
  PageBreakIcon,
  UniqueIdIcon,
  UploadImageIcon,
  DataModelIcon,
  FormulaIcon,
  NumberIcon,
  FrequencyIcon,
  AggregatorIcon,
  FormIcon,
  DateRangeIcon,
} from "@components/icons";

export function getIconFromElementType(type: ElementType, color: string = "#333") {
  switch (type) {
    case ElementType.Users:
      return <UserIcon color={color} />;
    case ElementType.Entities:
      return <EntityIcon color={color} />;
    case ElementType.LocationPicker:
      return <LocationPickerIcon color={color} />;
    case ElementType.Video:
      return <VideoIcon color={color} />;
    case ElementType.SingleLineInputBox:
      return <SingleLinetextIcon color={color} />;
    case ElementType.MultiLineInputBox:
      return <MultiLinetextIcon color={color} />;
    case ElementType.SingleChoice:
      return <SingleChoiceIcon color={color} />;
    case ElementType.MultiChoice:
      return <MultipleChoiceIcon color={color} />;
    case ElementType.DatePicker:
      return <DateTimeIcon color={color} />;
    case ElementType.DateRangePicker:
      return <DateRangeIcon color={color} />;
    case ElementType.FileUpload:
      return <FileUploadIcon color={color} />;
    case ElementType.Rating:
      return <RatingIcon color={color} />;
    case ElementType.Slider:
      return <SliderIcon color={color} />;
    case ElementType.SingleDropdownSelect:
      return <DropDownIcon color={color} />;
    case ElementType.MultipleDropdownSelect:
      return <MultiSelectIcon color={color} />;
    case ElementType.Expression:
      return <TextBlockIcon color={color} />;
    case ElementType.Ranking:
      return <RankingIcon color={color} />;
    case ElementType.RichText:
      return <RichTextIcon color={color} />;
    case ElementType.Signature:
      return <SignatureIcon color={color} />;
    case ElementType.YesNo:
      return <YesNoIcon color={color} />;
    case ElementType.Email:
      return <Email color={color} />;
    case ElementType.MobileNumber:
      return <MobilePoIcon color={color} />;
    case ElementType.Link:
      return <LinkIcon color={color} />;
    case ElementType.Name:
      return <UserIcon color={color} />;
    case ElementType.Currency:
      return <MoneyIcon color={color} />;
    case ElementType.DataModel:
      return <DataModelIcon color={color} />;
    case ElementType.TermsAndConditons:
      return <TermsConditionIcon color={color} />;
    case ElementType.TimePicker:
      return <TimeIcon color={color} />;
    case ElementType.PreviewImage:
      return <ImageIcon color={color} />;
    case ElementType.PageBreak:
      return <PageBreakIcon color={color} />;
    case ElementType.UniqueId:
      return <UniqueIdIcon color={color} />;
    case ElementType.ImageUpload:
      return <UploadImageIcon color={color} />;
    case ElementType.Formula:
      return <FormulaIcon color={color} />;
    case ElementType.Number:
      return <NumberIcon color={color} />;
    case ElementType.Frequency:
      return <FrequencyIcon color={color} />;
    case ElementType.Aggregator:
      return <AggregatorIcon color={color} />;
    case ElementType.Repeater:
      return <FormIcon color={color} />;
  }
}

export function getElementPlaceHolder(type: ElementType): string | undefined {
  switch (type) {
    case ElementType.Entities:
      return "Select Entity(s)";
    case ElementType.Users:
      return "Select User(s)";
    case ElementType.Currency:
      return "Enter Amount";
    case ElementType.MobileNumber:
      return "Enter Mobile Number";
    case ElementType.Email:
      return "Enter Email Id";
    case ElementType.SingleLineInputBox:
    case ElementType.MultiLineInputBox:
    case ElementType.RichText:
      return "Type Something";
    case ElementType.DatePicker:
    case ElementType.DateRangePicker:
      return "Select a date";
    case ElementType.SingleDropdownSelect:
      return "Select an item";
    case ElementType.MultipleDropdownSelect:
      return "Select item(s)";
    case ElementType.ImageUpload:
      return "Capture or Upload Image";
    case ElementType.Number:
      return "Enter a number";
  }
}

export function isEntityTypeQuestion(question?: Question) {
  return question?.title === "Entities";
}

export function isUsersTypeQuestion(question?: Question) {
  return question?.title === "Users";
}

export const isInputQuestionType = (type: ElementType) => {
  return (
    type !== ElementType.Expression &&
    type !== ElementType.Video &&
    type !== ElementType.PreviewImage &&
    type !== ElementType.PageBreak
  );
};

export const isNumericalType = (type: ElementType) => {
  return (
    type === ElementType.Aggregator ||
    type === ElementType.Currency ||
    type === ElementType.Number ||
    type === ElementType.Formula ||
    type === ElementType.Slider ||
    type === ElementType.Rating
  );
};

export const isStringType = (type: ElementType) => {
  return type === ElementType.SingleLineInputBox || type === ElementType.MultiLineInputBox;
};

export const isSortableField = (type: ElementType) => {
  return (
    type === ElementType.SingleLineInputBox ||
    type === ElementType.MultiLineInputBox ||
    type === ElementType.Email ||
    type === ElementType.Rating ||
    type === ElementType.Currency ||
    type === ElementType.Name ||
    type === ElementType.YesNo ||
    type === ElementType.Number ||
    type === ElementType.Formula ||
    type === ElementType.Aggregator ||
    type === ElementType.UniqueId ||
    type === ElementType.DatePicker ||
    type === ElementType.TimePicker ||
    type === ElementType.Link ||
    type === ElementType.SingleDropdownSelect ||
    type === ElementType.SingleChoice ||
    type === ElementType.Users ||
    type === ElementType.Entities
  );
};

export const isStaticField = (type: ElementType) => {
  return (
    type !== ElementType.DataModel &&
    type !== ElementType.Repeater &&
    type !== ElementType.PageBreak &&
    type !== ElementType.Video &&
    type !== ElementType.PreviewImage &&
    type !== ElementType.Expression &&
    type !== ElementType.Ranking
  );
};

export const CameraFacingModeTypes = [CAMERA_FACING_MODE.FRONT, CAMERA_FACING_MODE.REAR];
